export default __webpack_public_path__ + "static/media/path.8b67d003.svg";